document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("open-contact-drawer");
  const drawer = document.getElementById("contact-drawer");
  const closeBtn = document.getElementById("close-contact-drawer");

   console.log("I am contact-drawer")
  if (openBtn && drawer && closeBtn) {
    openBtn.addEventListener("click", () => drawer.classList.add("open"));
    closeBtn.addEventListener("click", () => drawer.classList.remove("open"));
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("open-contact-drawer_footer");
  const drawer = document.getElementById("contact-drawer");
  const closeBtn = document.getElementById("close-contact-drawer");

   console.log("I am contact-drawer")
  if (openBtn && drawer && closeBtn) {
    openBtn.addEventListener("click", () => drawer.classList.add("open"));
    closeBtn.addEventListener("click", () => drawer.classList.remove("open"));
  }
});
// document.addEventListener('DOMContentLoaded', function () {
//   const drawer = document.getElementById('contactDrawer');
//   const openBtn = document.querySelector('[data-open-contact-drawer]');
//   const closeBtn = document.getElementById('closeDrawer');

//   if (openBtn && drawer) {
//     openBtn.addEventListener('click', () => {
//       drawer.classList.add('open');
//     });
//   }

//   if (closeBtn && drawer) {
//     closeBtn.addEventListener('click', () => {
//       drawer.classList.remove('open');
//     });
//   }
// });
